/**
 * 无全部品类功能品类
 */
export const NOALLCATEGORYLIST = ['10111025', '10111018', '10111020', '10111021', '10111113']
/**
 * 有全部品类 品类
 */

export const HASALLCATEGORYLIST = [
  '101317', //技能培训
  '101123', //孕婴健康
  '10111112', //抚触
  '10111114' //推拿
]
// 产后恢复-三级品类
export const RECOVERYCATEGORY = '101121'
/**
 * 特殊品类 暂时不做
 */

export const specialCategory = [] // [10111110]


export interface TgObj {
  text: string
  value: number
  other?: any
}

export const TENANTGOODS: TgObj[] = [
  {
    text: '商户',
    value: 1
    //other: { text: '好评多', value: 'star' }
  }
  // {
  //   text: '商品',
  //   value: 2,
  //   other: { text: '销量', value: 'sales' }
  // }
]

export const ALLTENANTGOODS: TgObj[] = [
  {
    text: '商户',
    value: 1,
    other: { text: '好评多', value: 'star' }
  },
  {
    text: '商品',
    value: 2,
    other: { text: '销量', value: 'sales' }
  }
]
